import { render, staticRenderFns } from "./Partin.vue?vue&type=template&id=6a42dbb0&"
import script from "./Partin.vue?vue&type=script&lang=js&"
export * from "./Partin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a42dbb0')) {
      api.createRecord('6a42dbb0', component.options)
    } else {
      api.reload('6a42dbb0', component.options)
    }
    module.hot.accept("./Partin.vue?vue&type=template&id=6a42dbb0&", function () {
      api.rerender('6a42dbb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Partin.vue"
export default component.exports